const BASE_URL = 'https://';

const DOMAINS = {
  fb: 'facebook.com/',
  instagram: 'instagram.com/',
  twitter: 'twitter.com/',
  twitch: 'twitch.com/',
  discord: 'discord.com/',
  youtube: 'youtube.com/',
};

export const getSocialLink = (socialType, id) =>
  `${BASE_URL}${DOMAINS[socialType]}${id}`;
